// Main.js
import React, { useEffect, useRef, useState } from "react";
import { Container } from "react-bootstrap";
import Daimond from "../assets/daimond.png";
import daimondbox from "../assets/daimondbox.png";

export const MainFive = () => {
  const sectionOneRef = useRef(null);
  const nacklessectionOneRef = useRef(null);
  const sectionTwoRef = useRef(null);
  const necklaceRef = useRef(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      if (!isAnimating) {
        const sectionOneBottom = sectionOneRef.current.getBoundingClientRect().bottom;
        if (sectionOneBottom <= window.innerHeight && st > lastScrollTop) {
          // Scrolling down
          setIsAnimating(true);
          sectionOneRef.current.classList.add('hidden');
          sectionTwoRef.current.classList.add('visible');
          necklaceRef.current.classList.remove('backanimate');
          necklaceRef.current.classList.add('animate');

          setTimeout(() => {
            setIsAnimating(false);
          }, 2000); // Duration of the animation
        } else if (st < lastScrollTop) {
          // Scrolling up
          setIsAnimating(true);
          sectionOneRef.current.classList.remove('hidden');
          sectionTwoRef.current.classList.remove('visible');
          necklaceRef.current.classList.remove('animate');
          necklaceRef.current.classList.add('backanimate');

          setTimeout(() => {
            setIsAnimating(false);
          }, 2000); // Duration of the back animation
        }
      }
      setLastScrollTop(st <= 0 ? 0 : st); // For Mobile or negative scrolling
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isAnimating, lastScrollTop]);

  return (
    <>
      <section id="sectionFive" ref={sectionOneRef}>
        <Container>
          <div className="text-left">
            <h2>if you can imagine we <br/>can design it</h2>
          </div>
          <div className="necklace" ref={nacklessectionOneRef}>
            <img src={Daimond} id="daimond" ref={necklaceRef} />
          </div>
        </Container>
      </section>
      <section id="sectionFive" ref={sectionTwoRef}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="pad-col">
                <img src={daimondbox} className="daimondbox" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
